import { useEffect, useState } from "react";
import Accordion from "react-bootstrap/esm/Accordion";
import Card from "react-bootstrap/esm/Card";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import { retrieveAccordion } from "../../redux/slice/accordion-slice";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../redux/store";
import Convergence2023Banner from "./components/convergence-2023-banner";

const Convergence2023Register = () => {
  const path = "Convergence-2023%2FRegister";
  const dispatch = useAppDispatch();
  const { RapsEuropeData: pageMenuData } = useSelector((state: RootState) => state.rapsEurope);
  const { AccordionData } = useSelector((state: RootState) => state.Accordion);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
    dispatch(retrieveAccordion(`%2F${path}%2FAccordion-Items`));
  }, [dispatch]);

  // Dynamic Scripts
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    if (pageMenuData[0]?.result[0]) {
      if (pageMenuData[0]?.result[0].javaScriptField) {
        setScriptHtmlString(pageMenuData[0].result[0].javaScriptField);
      }

      if (window.runGlobalScripts) {
        window.runGlobalScripts();
      }
    }
  }, [pageMenuData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString, divId: "convergence-2023-register-script" });
  // End Dynamic Scripts

  return (
    <>
      <Convergence2023RegisterStyleComponent />
      <Helmet>
        <title>{pageMenuData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <Convergence2023Banner
        bannerImage={pageMenuData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={pageMenuData[0]?.result[0]?.mobileHeaderImage}
        headerText={pageMenuData[0]?.result[0]?.headerText}
        topCommonMesage={pageMenuData[0]?.result[0]?.topCommonMesage}
      />
      <br />
      <div className="container">
        <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.description, }}></div>
        <div className="col-md-12">
          <Accordion alwaysOpen flush className="convergence convergence-primary">
            {AccordionData[0]?.data?.map((item, index) => {
              return (
                <Card key={index}>
                  <Accordion.Item eventKey={index.toString()} key={index}>
                    <Card.Header>
                      <Accordion.Header className="btn btn-block heading">
                        <span className="heading">
                          <strong dangerouslySetInnerHTML={{ __html: item.name }}></strong>
                          <i aria-hidden="true" className="fa fa-angle-double-down" id="fa-angle-arrow">
                            &nbsp;
                          </i>
                        </span>
                      </Accordion.Header>
                    </Card.Header>
                    <Accordion.Body dangerouslySetInnerHTML={{ __html: item.description }}></Accordion.Body>
                  </Accordion.Item>
                </Card>
              );
            })}
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default Convergence2023Register;

const Convergence2023RegisterStyleComponent = () => {
  return (
    <>
      <style>
        {`
          .heading { float: left; white-space: break-spaces; color: inherit; }
          .convergence .accordion-button{
            font-size: 1rem;
          }
          .accordion-button:not(:disabled):not(.disabled):active, .accordion-button:not(:disabled):not(.disabled).active{
            color: #186DB4;
            background-color: #fff;
            border-color: #186DB4;
          }
          .table{
            margin-top: 0;
            font-size: 1rem
          }
          .accordion .card{
            margin-top: 0;
            margin-bottom: 0;
          }
          .convergence .accordion-button{
            font-weight: 700;
            text-transform: uppercase;
          }
          .lead{
            margin-bottom: 0;
          }
          .table td, th{
            margin-top: 0;
            font-size: 1rem;
            padding: 0.75rem !important;
          }
          .accordion-item .card-header{
            width: 100%;
            display: flex
          }
          .card-body{
            padding: 1.25rem;
          }
        `}
      </style>
    </>
  );
};
